// extracted by mini-css-extract-plugin
module.exports = {"infoBlocks":"Info-module--infoBlocks--3E4KN","description":"Info-module--description--2TIBs"};